var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMldBloodCollection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.524 5.151v4.954",
    stroke: "url(#0st6f70c4a)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.073 5.151v4.954",
    stroke: "url(#gh0c5w4j7b)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.381 10.231V3.347c0-1.007-.923-1.847-2.015-1.847H17.681c-1.091 0-2.015.84-2.015 1.847v6.926h13.265v-5.12",
    stroke: "url(#6y4k2h14ec)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.744 14.345V39.7c0 3.736-3.274 6.8-7.22 6.8-3.946 0-7.22-3.064-7.22-6.8V10.735",
    stroke: "url(#qt9jcn3i7d)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.471 35.25h7.682c.798 0 1.47-.63 1.47-1.344V18.67c0-.756-.672-1.344-1.47-1.344h-7.682",
    stroke: "url(#56hsc5815e)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.341 21.985h-5.08",
    stroke: "url(#w2y4bh0off)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.341 26.267h-5.08",
    stroke: "url(#taek2dcjwg)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.341 30.549h-5.08",
    stroke: "url(#7t5n6ekhih)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0st6f70c4a",
    x1: 24.524,
    y1: 0.211,
    x2: 25.524,
    y2: 0.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gh0c5w4j7b",
    x1: 20.073,
    y1: 0.211,
    x2: 21.073,
    y2: 0.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6y4k2h14ec",
    x1: 15.666,
    y1: -7.25,
    x2: 33.381,
    y2: -7.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qt9jcn3i7d",
    x1: 17.304,
    y1: -24.935,
    x2: 31.744,
    y2: -24.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "56hsc5815e",
    x1: 17.471,
    y1: -0.552,
    x2: 26.622,
    y2: -0.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w2y4bh0off",
    x1: 17.262,
    y1: 20.988,
    x2: 22.341,
    y2: 20.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "taek2dcjwg",
    x1: 17.262,
    y1: 25.269,
    x2: 22.341,
    y2: 25.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7t5n6ekhih",
    x1: 17.262,
    y1: 29.552,
    x2: 22.341,
    y2: 29.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMldBloodCollection);
export default __webpack_public_path__ + "static/media/mld-blood-collection.4ffe884086bdb4e558f0ca9fa3cd86a9.svg";
export { ForwardRef as ReactComponent };